/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelRecordDataActualSplitRange'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ForecastModelRecordDataActualSplitRange'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelRecordDataFileReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelRecordDataActualSplitRange);
  }
}(this, function(ApiClient, ForecastModelRecordDataActualSplitRange) {
  'use strict';




  /**
   * The ForecastModelRecordDataFileReport model module.
   * @module model/ForecastModelRecordDataFileReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForecastModelRecordDataFileReport</code>.
   * @alias module:model/ForecastModelRecordDataFileReport
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>ForecastModelRecordDataFileReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForecastModelRecordDataFileReport} obj Optional instance to populate.
   * @return {module:model/ForecastModelRecordDataFileReport} The populated <code>ForecastModelRecordDataFileReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ActualSplitRanges')) {
        obj['ActualSplitRanges'] = ApiClient.convertToType(data['ActualSplitRanges'], [ForecastModelRecordDataActualSplitRange]);
      }
      if (data.hasOwnProperty('RecordID')) {
        obj['RecordID'] = ApiClient.convertToType(data['RecordID'], 'Integer');
      }
      if (data.hasOwnProperty('SheetExcelConfigurationID')) {
        obj['SheetExcelConfigurationID'] = ApiClient.convertToType(data['SheetExcelConfigurationID'], 'Integer');
      }
      if (data.hasOwnProperty('LocalFileName')) {
        obj['LocalFileName'] = ApiClient.convertToType(data['LocalFileName'], 'String');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ForecastModelRecordDataActualSplitRange>} ActualSplitRanges
   */
  exports.prototype['ActualSplitRanges'] = undefined;
  /**
   * @member {Integer} RecordID
   * @default 0
   */
  exports.prototype['RecordID'] = 0;
  /**
   * @member {Integer} SheetExcelConfigurationID
   */
  exports.prototype['SheetExcelConfigurationID'] = undefined;
  /**
   * @member {String} LocalFileName
   * @default ''
   */
  exports.prototype['LocalFileName'] = '';
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


